import { formatMs } from "@material-ui/core";
import {
  FETCH_UNITS,
  ADD_NEW_UNIT,
  ADD_NEW_UNITS,
  START_LOADING,
  END_LOADING,
  UPDATE_UNIT,
  DELETE_UNIT,
  MAP_UNIT,
  DELETE_MAPPING,
  ADD_MAPPING,
  FETCH_MAPPINGS,
  UPDATE_MAPPING,
} from "../actions/constants";

// Import the dummy units

const initialState = {
  isLoading: false, // Set to false since we have initial data
  units: [], // Use dummy units as initial state
  mappings: [],
};

const unitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };

    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_UNITS:
      return {
        ...state,
        units: action.payload,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };

    // case ADD_NEW_UNIT:
    //   return { ...state, units: [...state.units, action.payload] };

    case ADD_NEW_UNITS:
      return { ...state, units: [...state.units, ...action.payload] };

    case UPDATE_UNIT:
      return {
        ...state,
        units: state.units.map((unit) =>
          unit._id === action.payload._id ? action.payload : unit
        ),
      };

    case DELETE_UNIT:
      return {
        ...state,
        units: state.units.filter((unit) => unit._id !== action.payload),
      };

    case MAP_UNIT:
      return {
        ...state,
        units: state.units.map((unit) =>
          unit._id === action.payload._id ? action.payload : unit
        ),
      };

    case ADD_NEW_UNIT:
      return { ...state, units: [...state.units, action.payload] };
    case FETCH_MAPPINGS:
      return { ...state, mappings: action.payload };

    case ADD_MAPPING:
      return { ...state, mappings: [...state.mappings, action.payload] };
    case DELETE_MAPPING:
      return {
        ...state,
        mappings: state.mappings.filter((m) => m._id !== action.payload),
      };

    case UPDATE_MAPPING: // Add this case
      return {
        ...state,
        mappings: state.mappings.map((mapping) =>
          mapping._id === action.payload._id ? action.payload : mapping
        ),
      };

    default:
      return state;
  }
};

export default unitsReducer;
